import {
  useFetchInsuranceEstimate,
  useGetBookingSession,
  useSubmitInsurance,
} from '@massilia/queries'
import { createFileRoute } from '@tanstack/react-router'

import { bookingSessionSearchSchema } from '@/lib/schemas/booking-session-search.schema'
import { AssurancesPage } from '@/routes/assurances/-components/assurances-page'

export const Route = createFileRoute('/_booking/assurances')({
  component: AssurancesRoute,
  validateSearch: bookingSessionSearchSchema,
})

function AssurancesRoute() {
  const { session: sessionId } = Route.useSearch()

  const { data: session, isLoading } = useGetBookingSession(sessionId, { throwOnError: true })

  const shouldFetchEstimate = session?.insuranceEstimateStatus === 'PENDING'
  const { isLoading: isLoadingEstimate } = useFetchInsuranceEstimate(sessionId, shouldFetchEstimate)
  const { isPending: isSubmitting, mutateAsync: submitInsurance } = useSubmitInsurance(sessionId, {
    throwOnError: true,
  })

  return (
    <AssurancesPage
      isLoading={isLoading}
      isLoadingEstimate={isLoadingEstimate}
      isSubmitting={isSubmitting}
      session={session}
      sessionId={sessionId}
      submitInsurance={submitInsurance}
    />
  )
}
